import { render, staticRenderFns } from "./Carouselitem.vue?vue&type=template&id=1a51cac0&scoped=true"
import script from "./Carouselitem.vue?vue&type=script&lang=js"
export * from "./Carouselitem.vue?vue&type=script&lang=js"
import style0 from "./Carouselitem.vue?vue&type=style&index=0&id=1a51cac0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a51cac0",
  null
  
)

export default component.exports